const ProductSearchDropdown = ({
  productSearch,
  productResults,
  loadingProducts,
  productId,
  onInputChange,
  onSelect,
}) => (
  <div className="mb-4">
    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-widest mb-2">
      Product (Optional)
    </label>
    <div className="relative">
      <input
        type="text"
        placeholder="Search and select a product..."
        value={productSearch}
        onChange={(e) => onInputChange(e.target.value)}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-black placeholder-gray-400 focus:outline-none focus:border-black focus:bg-white transition-all duration-200"
      />
      {loadingProducts && (
        <p className="mt-1 text-xs text-gray-500 px-1">Loading products...</p>
      )}
      {productResults.length > 0 && !productId && (
        <div className="absolute top-full left-0 right-0 bg-white border border-gray-200 border-t-0 rounded-b-xl max-h-48 overflow-y-auto z-[1000] shadow-lg">
          {productResults.map((product) => (
            <div
              key={product._id}
              onClick={() => onSelect(product)}
              className="px-4 py-3 text-sm text-gray-700 border-b border-gray-100 cursor-pointer hover:bg-gray-50 last:border-b-0"
            >
              {product.productName}
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default ProductSearchDropdown;
